<span [class]="badgeCssClass()">
  <ng-content />
</span>
